import React from "react";
import Card from "../Card"
import LineChart from "../LineChart";
import i18n from "i18n";
import styles from "./MainApp.organisms.Dashboard.MonthlySalesCard.module.scss";

const MonthlySalesCard = ({ series, xCategories }) => {
  return (
    <div className={styles["monthly-sales-card-container"]}>
      <Card>
        <div className={styles["title-container"]}>
          <h1 className={styles["dashboard-card-title"]}>{i18n.t("monthly.sales")}</h1>
        </div>

        <div className={styles["most-selled-table"]}>
          <LineChart series={series} xCategories={xCategories}/>
        </div>
      </Card>
    </div>
  );
};

export default MonthlySalesCard;
